export default {
    state: {
        brandList: [],
        brandListLoading: false,
    },
    actions: {
        async fetchBrandList(ctx) {
            ctx.commit('updateBrandListLoading', true)
            const requestParams = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
            };
            const res = await fetch("/api/brand/", requestParams);
            if (!res.ok) {
                this._vm.$toast.dismiss(toastWaitId)
                this._vm.$toast.error("Error:" + res['error'], {timeout: 5000})
                ctx.commit('updateBrandListLoading', false)
                return
            }
            const brandList = await res.json();
            ctx.commit('updateBrandList', brandList)
            ctx.commit('updateBrandListLoading', false)
        },
    },
    mutations: {
        updateBrandList(state, brandList) {
            state.brandList = brandList
        },
        updateBrandListLoading(state, brandListLoading) {
            state.brandListLoading = brandListLoading
        },
    },
    getters: {
        getBrandList(state) {
            return state.brandList
        },
        getBrandListLoading(state) {
            return state.brandListLoading
        },
    }
}